const getFullName = ({ firstName, lastName }: { firstName?: string; lastName?: string }): string => `${firstName ?? ''} ${lastName ?? ''}`.trim();

export default getFullName;
